import { Components, inputBaseClasses, inputClasses, Theme } from '@mui/material';

// Exporting these values to allow re-use in some component-specific code where
// additional overrides are needed.
export const INPUT_BASE_PADDING_Y_PX = {
  medium: 6,
  small: 2,
};

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        backgroundColor: theme.palette.input.backgroundColor,
        ...(theme.featureFlags.panwRebrandStubYear && {
          '&:hover': {
            backgroundColor: theme.palette.input.hoverBackgroundColor,
          },
          [`&.${inputBaseClasses.focused}`]: {
            backgroundColor: theme.palette.input.hoverBackgroundColor,
          },
          [`&.${inputBaseClasses.disabled}`]: {
            backgroundColor: theme.palette.input.disabledBackgroundColor,
          },
        }),
        // Standard (underlined) inputs should be transparent, not filled.
        // Uses CSS class instead of ownerState.variant which is unreliable
        // for Select variant="standard".
        [`&.${inputClasses.root}`]: {
          backgroundColor: 'transparent',
          ...(theme.featureFlags.panwRebrandStubYear && {
            '&:hover': {
              backgroundColor: theme.palette.input.hoverBackgroundColor,
            },
            [`&.${inputBaseClasses.focused}`]: {
              backgroundColor: theme.palette.input.hoverBackgroundColor,
            },
            [`&.${inputBaseClasses.disabled}`]: {
              backgroundColor: theme.palette.input.disabledBackgroundColor,
            },
          }),
        },
        paddingTop: `${INPUT_BASE_PADDING_Y_PX.medium}px !important`,
        paddingBottom: `${INPUT_BASE_PADDING_Y_PX.medium}px !important`,
        [`&.${inputBaseClasses.adornedStart}`]: {
          paddingTop: '5px !important',
          paddingBottom: '5px !important',
        },
      };
    },
    sizeSmall: {
      paddingTop: `${INPUT_BASE_PADDING_Y_PX.small}px !important`,
      paddingBottom: `${INPUT_BASE_PADDING_Y_PX.small}px !important`,
    },
    input: ({ theme }) => ({
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
      ...(theme.featureFlags.panwRebrandStubYear && {
        '&::placeholder': {
          color: theme.palette.input.placeholderColor,
          opacity: 1,
        },
      }),
    }),
    inputSizeSmall: {
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
    },
  },
};
